import { createContext, useContext, useState, useEffect } from "react";
import { de } from "./i18n/de";
import { es } from "./i18n/es";
import { zh } from "./i18n/zh";

const translations = {
  it: {
    nav_experiences: "Experiences",
    nav_destinations: "Destinations",
    nav_boat: "Capri e le Isole",
    nav_taste: "Taste",
    nav_stay: "Stay",
    nav_create: "Create Your Experience",
    nav_book: "Book Your Experience",
    sign_in: "Accedi",
    sign_out: "Esci",
    account_greeting: "Ciao",
    map_hint: "Esplora la mappa — passa il cursore sui luoghi",
    choose_date: "Data",
    participants: "Partecipanti",
    time_slot: "Fascia oraria",
    slot_morning: "Mattina",
    slot_afternoon: "Pomeriggio",
    slot_evening: "Sera",
    addons_label: "Servizi aggiuntivi",
    estimated_total: "Totale stimato",
    send_request: "Invia richiesta di prenotazione",
    whatsapp_context: "Prenota su WhatsApp",
    ask_questions: "Hai domande? Scrivici",
    save_experience: "Salva esperienza",
    saved_favorite: "Esperienza salvata",
    removed_favorite: "Rimossa dai salvati",
    login_to_save: "Accedi per salvare e gestire le tue esperienze",
    request_sent: "Richiesta inviata",
    request_sent_sub: "Abbiamo ricevuto la tua richiesta. Ti ricontatteremo al più presto per confermare disponibilità e dettagli.",
    remove: "Rimuovi",
    account_title: "Il mio account",
    account_signin_sub: "Accedi per vedere le tue richieste e le esperienze salvate.",
    my_requests: "Le mie richieste",
    my_experiences: "Le mie esperienze",
    no_requests: "Non hai ancora inviato richieste.",
    no_favorites: "Non hai ancora salvato nessuna esperienza.",
    discover_experiences: "Scopri le esperienze",
    custom_request: "Richiesta personalizzata",
    requested_on: "Richiesta del",
    status_inviata: "Richiesta inviata",
    status_attesa: "In attesa di conferma",
    status_confermata: "Confermata",
    status_completata: "Completata",
    status_annullata: "Annullata",
    cookie_banner_text: "Utilizziamo cookie tecnici necessari e, solo con il tuo consenso, cookie analitici per migliorare l'esperienza. Puoi modificare la tua scelta in qualsiasi momento.",
    cookie_accept_all: "Accetta tutti",
    cookie_reject: "Rifiuta",
    cookie_customize: "Personalizza",
    cookie_save_prefs: "Salva preferenze",
    cookie_necessary: "Cookie necessari (sempre attivi)",
    cookie_analytics: "Cookie analitici",
    manage_cookies: "Gestisci preferenze cookie",
    search_placeholder: "Cerca esperienza o luogo…",
    related_title: "Visite consigliate",
    what_to_bring: "Cosa portare",
    wtb_1: "Scarpe comode e una bottiglia d'acqua",
    wtb_2: "Costume, asciugamano e crema solare per le esperienze di mare",
    wtb_3: "Abbigliamento a strati per trekking e montagna",
    boat_hero_note: "Escursioni private • Tramonto • Aperitivo • Esperienze personalizzate",
    boat_hero_sub2: "Il mare di Napoli vissuto da una prospettiva completamente diversa.",
    discover_experience: "Scopri l'esperienza",
    faq_page_title: "Domande frequenti",
    faq_page_sub: "Prenotazioni, pagamenti, cancellazioni, meteo e tutto quello che serve sapere.",
    need_help: "Hai bisogno di aiuto?",
    booking_info: "Informazioni sulle prenotazioni",
    cancellation_policy: "Politica di cancellazione",
    all_faqs: "Tutte le FAQ",
    admin_title: "Area amministratore",
    admin_denied: "Accesso riservato. Accedi con un account amministratore.",
    admin_link: "Pannello admin",
    tab_overview: "Panoramica",
    tab_requests: "Richieste",
    tab_experiences: "Esperienze",
    tab_users: "Utenti",
    stats_requests: "Richieste totali",
    stats_users: "Utenti registrati",
    stats_experiences: "Esperienze attive",
    stats_favorites: "Salvataggi",
    change_status: "Cambia stato",
    featured_label: "In evidenza",
    save_label: "Salva",
    saved_ok: "Salvato",
    price_edit: "Prezzo (da)",
    day_title: "Crea la tua giornata in Campania",
    day_sub: "Scegli cosa vuoi vivere: combiniamo automaticamente mare, cultura, gusto e natura in un itinerario su misura.",
    day_pick: "Cosa vuoi vivere?",
    day_area: "Dove vuoi stare?",
    day_area_all: "Ovunque in Campania",
    day_people: "In quanti?",
    day_generate: "Genera il mio itinerario",
    day_itinerary: "Il tuo itinerario",
    day_morning: "Mattina",
    day_afternoon: "Pomeriggio",
    day_evening: "Sera",
    day_empty: "Seleziona almeno due dimensioni per generare l'itinerario.",
    day_send: "Richiedi questo itinerario",
    day_sent_title: "Itinerario richiesto",
    day_sent_sub: "Abbiamo ricevuto il tuo itinerario ideale. Lo trasformiamo in una proposta concreta e ti ricontattiamo.",
    day_per_person: "a persona",
    day_edit: "Modifica selezione",
    tab_contacts: "Contatti",
    nav_companion: "Companion",
    companion_title: "Flegrea Companion",
    companion_sub: "La tua guida di viaggio: letture e storie dei luoghi che visiterai, e i tuoi servizi sempre a portata di mano con il supporto del nostro staff.",
    langs_note: "presto disponibili",
    readings_title: "Letture e approfondimenti",
    min_read: "min di lettura",
    back_companion: "Tutte le storie",
    your_services: "I tuoi servizi",
    support_staff: "Supporto staff",
    support_title: "Serve una mano?",
    support_sub: "Gestisci tutto in autonomia, e quando serve il nostro staff è a un messaggio di distanza.",
    pay_online: "Paga online",
    pay_online_note: "Pagamento sicuro con Stripe. La disponibilità resta soggetta a conferma.",
    payment_processing: "Stiamo verificando il pagamento…",
    payment_success_title: "Pagamento riuscito",
    payment_success_sub: "Grazie! La tua richiesta è confermata lato pagamento. Ti contatteremo per confermare disponibilità e dettagli dell'esperienza.",
    payment_success_pending_note: "Se hai completato il pagamento, la conferma potrebbe richiedere qualche minuto. Per dubbi scrivici su WhatsApp.",
    payment_check_again: "Verifica in corso",
    payment_cancel_title: "Pagamento annullato",
    payment_cancel_sub: "Nessun addebito è stato effettuato. Puoi riprovare quando vuoi o inviare la richiesta senza pagamento online.",
    back_home: "Torna alla home",
    contact_title: "Richiedi informazioni",
    contact_sub: "Semplice, veloce, conciso: scrivici e ti rispondiamo direttamente via email.",
    message_label: "Il tuo messaggio",
    send_message: "Invia richiesta",
    contact_sent: "Messaggio inviato",
    contact_sent_sub: "Grazie! Ti risponderemo al più presto all'indirizzo email indicato.",
    contact_required: "Compila nome, email e messaggio.",
    contact_error: "Invio non riuscito. Riprova o scrivici su WhatsApp.",
    contact_privacy_note: "Inviando accetti la Privacy Policy. Il messaggio arriva direttamente a info@flegreaexperience.com.",
    carousel_overline: "Il territorio",
    carousel_title: "La Campania, per davvero",
    carousel_sub: "Fotografie reali dai nostri tour. A breve: riprese da drone dei siti archeologici e delle uscite in barca.",
    tagline: "Discover Campania. Live the experience.",
    hero_line1: "Vivi la terra dove il Mediterraneo ",
    hero_line2: "incontra il fuoco.",
    hero_cta1: "Scopri le esperienze",
    hero_cta2: "Personalizza il tuo tour",
    dim_title: "What do you want to experience?",
    dim_sea: "SEA",
    dim_sea_desc: "Mare, isole, barche, canoe, coste e tramonti.",
    dim_culture: "CULTURE",
    dim_culture_desc: "Archeologia, storia, arte, borghi e patrimonio.",
    dim_nature: "NATURE",
    dim_nature_desc: "Vulcani, montagne, sentieri e attività outdoor.",
    dim_taste: "TASTE",
    dim_taste_desc: "Vino, cucina, prodotti locali e tradizioni gastronomiche.",
    explore_title: "Explore Campania",
    explore_sub: "Dai Campi Flegrei a Napoli, dalle isole al Vesuvio, dalla Costiera alle montagne dell'Appennino.",
    featured_title: "Featured Experiences",
    featured_sub: "Le esperienze più amate, curate dal nostro team.",
    bysea_title: "Flegrea by Sea",
    bysea_sub: "See Campania from a different perspective.",
    bysea_cta: "Discover Boat Experiences",
    taste_title: "Taste Campania",
    taste_sub: "A journey through the flavors of Campania.",
    taste_cta: "Discover Taste Experiences",
    beyond_title: "Beyond the Coast",
    beyond_sub: "Discover the wild side of Campania.",
    beyond_cta: "Discover Nature Experiences",
    create_title: "Non trovi quello che cerchi?",
    create_sub: "Costruiamo insieme la tua esperienza: tour privati, famiglie, coppie, gruppi, aziende, proposte romantiche, gastronomia e mare.",
    create_cta: "Crea il tuo tour",
    stay_title: "Stay With Us",
    stay_sub: "B&B e dimore selezionate: la base ideale per vivere il territorio.",
    stay_cta: "Discover Stays",
    why_title: "Why Flegrea Experience?",
    why_1: "Conosciamo il territorio oltre le guide turistiche",
    why_2: "Esperienze autentiche, non semplici visite",
    why_3: "Piccoli gruppi: più tempo, più attenzione, più autenticità",
    why_4: "Flessibilità: adattiamo l'esperienza alle tue esigenze",
    why_5: "Collaboriamo con realtà e professionisti del territorio",
    stories_title: "Una terra da raccontare",
    stories_sub: "Miti, eruzioni e imperatori: le storie dei Campi Flegrei, raccontate da chi questa terra la vive.",
    final_title: "Your Campania Story Starts Here",
    final_sub: "Scegli un'esperienza, aggiungi ciò che ami, oppure lascia che la creiamo per te.",
    copy_1: "Campania is more than a destination.",
    copy_2: "It is ancient cities, volcanic landscapes, Mediterranean islands, hidden villages, mountain trails, extraordinary food and stories that have survived for centuries.",
    copy_3: "Flegrea Experience was created to help you experience all of it.",
    copy_4: "From the Campi Flegrei to Naples, from Procida and Ischia to Pompeii, from the Amalfi Coast to the mountains bordering Abruzzo and Molise.",
    copy_5: "Choose an experience. Add what you love. Or let us create it for you.",
    copy_cta: "Discover Campania",
    exp_page_title: "Experiences",
    exp_page_sub: "Esperienze curate in tutta la Campania. Scegli la tua, oppure combinale con i nostri taste add-on.",
    filter_all: "Tutte",
    filter_culture: "Culture & History",
    filter_sea: "Sea & Islands",
    filter_canoe: "Canoe & Water",
    filter_nature: "Nature & Outdoor",
    filter_food: "Food",
    filter_wine: "Wine",
    filter_private: "Private",
    filter_night: "Night",
    offer_badge: "-10%",
    launch_offer: "Offerta di lancio — prezzo pieno barrato",
    all_destinations: "Tutte le destinazioni",
    results: "esperienze",
    from: "da",
    per_person: "a persona",
    price_note: "Prezzi indicativi, da confermare in fase di prenotazione.",
    discover: "Scopri l'esperienza",
    the_experience: "The Experience",
    highlights: "Highlights",
    included: "Included",
    not_included: "Not Included",
    addons_title: "Make It Taste Better",
    addons_sub: "Add a taste of Campania to your experience.",
    addons_price_each: "a persona",
    on_request: "Su richiesta",
    meet_guide: "Meet Your Guide",
    meet_guide_text: "Ogni esperienza è condotta da guide turistiche certificate e professionisti locali selezionati da Flegrea Experience. La conoscenza fa la differenza.",
    good_to_know: "Good to Know",
    gtk_1: "Le attività all'aperto sono soggette alle condizioni meteo e marine.",
    gtk_2: "Punto d'incontro e dettagli logistici vengono condivisi dopo la prenotazione.",
    gtk_3: "Le esperienze private possono essere personalizzate su richiesta.",
    faq_title: "FAQ",
    faq_q1: "In quali lingue sono disponibili le esperienze?",
    faq_a1: "Tutte le esperienze sono disponibili in italiano e inglese. Altre lingue su richiesta.",
    faq_q2: "Come funziona la prenotazione?",
    faq_a2: "Contattaci via WhatsApp o con il form: confermiamo disponibilità e dettagli, e riserviamo la tua esperienza. Nessun pagamento online richiesto in questa fase.",
    faq_q3: "Posso personalizzare un'esperienza?",
    faq_a3: "Sì. Ogni esperienza può essere arricchita con add-on gastronomici, transfer e servizi extra, oppure ricostruita da zero con Create Your Experience.",
    book_now: "Book Now",
    request_quote: "Request a Quote",
    duration: "Durata",
    group_size: "Partecipanti",
    location_label: "Località",
    languages_label: "Lingue",
    starting_price: "Prezzo di partenza",
    dest_page_title: "Destinations",
    dest_page_sub: "La Campania organizzata per territorio: scegli dove, poi scegli come viverla.",
    dest_experiences: "Esperienze in questa destinazione",
    view_destination: "Explore",
    boat_page_sub: "See Campania from a different perspective.",
    boat_departure: "Partenza",
    whats_included: "What's included",
    book_boat: "Prenota la tua esperienza in mare",
    taste_page_sub: "A journey through the flavors of Campania.",
    make_taste: "Make It Taste Better",
    make_taste_sub: "Add a taste of Campania to your experience. Quasi ogni esperienza può essere arricchita con un momento gastronomico.",
    territories_title: "Territori del Gusto",
    stay_page_sub: "Non semplici hotel: basi ideali per vivere il territorio, con esperienze a portata di mano.",
    check_availability: "Check Availability",
    rooms_label: "Camere",
    services_label: "Servizi",
    nearby_exp: "Esperienze vicine",
    stay_placeholder_note: "Struttura selezionata — dettagli e disponibilità in fase di definizione.",
    step1: "Who are you travelling with?",
    step2: "How many?",
    step3: "When?",
    step4: "What do you love?",
    step5: "Where?",
    step6: "Add something special",
    step7: "Tell us more",
    step8: "Contact",
    opt_solo: "Solo",
    opt_couple: "Couple",
    opt_family: "Family",
    opt_friends: "Friends",
    opt_group: "Group",
    more_than_10: "Più di 10 (richiesta personalizzata)",
    next: "Continua",
    back: "Indietro",
    submit: "Build My Experience",
    thankyou: "Thank you. Your Campania experience starts here.",
    thankyou_sub: "Abbiamo ricevuto la tua richiesta. Ti ricontatteremo al più presto per costruire la tua esperienza.",
    thankyou_wa: "Velocizza tutto su WhatsApp",
    name_label: "Nome",
    email_label: "Email",
    phone_label: "Telefono",
    whatsapp_label: "WhatsApp",
    notes_placeholder: "Raccontaci cosa sogni: occasioni speciali, ritmi, must-see, esigenze particolari...",
    footer_experiences: "Experiences",
    footer_legal: "Legal",
    footer_contacts: "Contatti",
    footer_follow: "Seguici",
    privacy: "Privacy",
    cookie: "Cookie",
    terms: "Terms & Conditions",
    wa_float: "Plan Your Experience",
    wa_message: "Ciao Flegrea Experience! Vorrei informazioni su:",
    wa_book_prefix: "Ciao! Vorrei prenotare l'esperienza:",
    wa_quote_prefix: "Ciao! Vorrei un preventivo per l'esperienza:",
    wa_stay_prefix: "Ciao! Vorrei verificare la disponibilità di:",
    badge_PRIVATE: "Private",
    badge_SMALL_GROUP: "Small Group",
    badge_SUMMER: "Summer",
    badge_BOAT: "Boat",
    badge_FOOD: "Food",
    badge_NATURE: "Nature",
    loading: "Caricamento...",
    not_found: "Esperienza non trovata",
    back_experiences: "Tutte le esperienze",
    back_destinations: "Tutte le destinazioni",
    about: "About",
    contact: "Contact",
    faq: "FAQ",
    nature_word: "Nature",
    step_of: "di",
    date_flexible: "Le mie date sono flessibili",
    chapters_title: "Il racconto, capitolo per capitolo",
    anecdote_overline: "Storie & miti del luogo",
    gallery_title: "La galleria",
    gallery_hint: "Scorri per esplorare",
    chat_float: "Assistente AI",
    chat_title: "Assistente Flegrea",
    chat_subtitle: "AI · info su esperienze e prenotazioni",
    chat_placeholder: "Scrivi un messaggio...",
    chat_send: "Invia",
    chat_greeting: "Ciao! Sono l'assistente di Flegrea Experience. Chiedimi pure informazioni sui nostri pacchetti, sui prezzi o su come prenotare — sono qui per aiutarti.",
    chat_error: "Qualcosa è andato storto. Riprova tra poco o scrivici su WhatsApp al +39 379 334 6030.",
    booking_form_title: "Richiedi informazioni",
    booking_form_sub: "Compila il form: ti rispondiamo entro 24 ore con disponibilità e prezzo su misura.",
    stay_help_title: "Hai bisogno dell'alloggio?",
    stay_help_sub: "Collaboriamo con dimore e B&B selezionati sul territorio. Scrivici le tue date e ti proponiamo la soluzione ideale, abbinata alle tue esperienze.",
    stay_help_cta: "Richiedi informazioni",
    nl_title: "Newsletter",
    nl_sub: "Iscriviti e ricevi il 10% di sconto sulla tua prima esperienza, oltre a storie e novità dal territorio.",
    nl_placeholder: "La tua email",
    nl_cta: "Iscriviti",
    nl_success: "Iscrizione confermata! Il tuo sconto del 10% è attivo: segnalalo quando prenoti via WhatsApp o email.",
    nl_error: "Controlla l'email inserita e riprova.",
    login_title: "Accedi",
    login_sub: "Accedi al tuo account Flegrea Experience",
    password_label: "Password",
    login_button: "Accedi",
    login_or: "oppure",
    login_google: "Continua con Google",
    tab_gallery: "Gallery",
    tab_stories: "Storie",
    admin_edit_content: "Modifica",
    hero_sub: "Tour, escursioni, mare, storia e sapori autentici nei Campi Flegrei.",
    story_cta: "Scopri la storia",
    nav_all_experiences: "Tutte le esperienze",
    nav_gallery: "Gallery",
    gallery_title: "Gallery",
    gallery_sub: "Tutti i luoghi delle nostre esperienze, fotografia dopo fotografia: dai vulcani dei Campi Flegrei alle isole, dalla Napoli sotterranea ai limoni di Sorrento.",
    gallery_videos_title: "Il territorio in movimento",
    gallery_videos_sub: "Riprese dal mare e dal territorio. Nuovi video — drone e racconti delle esperienze — in arrivo.",
    gallery_coming_soon: "In arrivo",
    gallery_photos_title: "Tutte le foto",
    gallery_seo_title: "Gallery — Foto e Video dei Campi Flegrei | Flegrea Experience",
    gallery_seo_desc: "Foto e video dei Campi Flegrei e della Campania: Pozzuoli, Baia, Bacoli, Napoli, Capri, Ischia, Procida, Sorrento, Pompei e il Vesuvio.",
    hero_alt_1: "La costa di Pozzuoli e i Campi Flegrei dal mare",
    hero_alt_2: "Il Castello Aragonese di Ischia",
    hero_alt_3: "Le case colorate di Corricella a Procida",
    hero_alt_4: "I Faraglioni di Capri",
    hero_alt_5: "Il borgo marinaro di Sant'Angelo a Ischia",
    seo_home_title: "Flegrea Experience — Tour ed Esperienze nei Campi Flegrei",
    seo_home_desc: "Esperienze autentiche nei Campi Flegrei: tour guidati a Pozzuoli, Baia, Bacoli, Lago d'Averno e Monte Nuovo, escursioni in barca a Capri, Ischia e Procida, storia e gastronomia.",
    seo_exp_title: "Esperienze nei Campi Flegrei — Tour, Mare, Storia e Sapori",
    seo_exp_desc: "Il catalogo completo delle esperienze: archeologia, vulcani, tour in barca, trekking e food experience tra Napoli, Campi Flegrei, Sorrento e Costiera Amalfitana.",
    seo_dest_title: "Destinazioni — Campi Flegrei, Napoli, Isole e Costiera",
    seo_dest_desc: "Pozzuoli, Baia, Bacoli, Napoli, Capri, Ischia, Procida, Sorrento, Pompei, Caserta e Matese: scegli dove vivere la tua esperienza in Campania.",
    seo_boat_title: "Capri e le Isole — Esperienze in Barca | Flegrea Experience",
    seo_boat_desc: "Tour in barca tra Capri, Ischia e Procida: uscite private, tramonti e aperitivi in mare, con partenza dai Campi Flegrei.",
    seo_taste_title: "Taste — Food & Wine Experience in Campania",
    seo_taste_desc: "Street food a Napoli, vini vulcanici, limoncello a Sorrento e cucina della tradizione: le esperienze gastronomiche di Flegrea Experience.",
    boat_cta_title: "Pronto a salpare?",
    boat_cta_sub: "Scrivici su WhatsApp e costruisci la tua giornata in mare nei Campi Flegrei.",
  },
  en: {
    nav_experiences: "Experiences",
    nav_destinations: "Destinations",
    nav_boat: "Capri & the Islands",
    nav_taste: "Taste",
    nav_stay: "Stay",
    nav_create: "Create Your Experience",
    nav_book: "Book Your Experience",
    sign_in: "Sign in",
    sign_out: "Sign out",
    account_greeting: "Hello",
    tagline: "Discover Campania. Live the experience.",
    hero_line1: "Live the land where the Mediterranean ",
    map_hint: "Explore the map — hover over the places",
    choose_date: "Date",
    participants: "Participants",
    time_slot: "Time slot",
    slot_morning: "Morning",
    slot_afternoon: "Afternoon",
    slot_evening: "Evening",
    addons_label: "Add-ons",
    estimated_total: "Estimated total",
    send_request: "Send booking request",
    whatsapp_context: "Book on WhatsApp",
    ask_questions: "Questions? Message us",
    save_experience: "Save experience",
    saved_favorite: "Experience saved",
    removed_favorite: "Removed from saved",
    login_to_save: "Sign in to save and manage your experiences",
    request_sent: "Request sent",
    request_sent_sub: "We have received your request. We will get back to you shortly to confirm availability and details.",
    remove: "Remove",
    account_title: "My account",
    account_signin_sub: "Sign in to see your requests and saved experiences.",
    my_requests: "My requests",
    my_experiences: "My experiences",
    no_requests: "You have not sent any requests yet.",
    no_favorites: "You have not saved any experiences yet.",
    discover_experiences: "Discover experiences",
    custom_request: "Custom request",
    requested_on: "Requested on",
    status_inviata: "Request sent",
    status_attesa: "Pending confirmation",
    status_confermata: "Confirmed",
    status_completata: "Completed",
    status_annullata: "Cancelled",
    cookie_banner_text: "We use necessary technical cookies and, only with your consent, analytics cookies to improve the experience. You can change your choice at any time.",
    cookie_accept_all: "Accept all",
    cookie_reject: "Reject",
    cookie_customize: "Customise",
    cookie_save_prefs: "Save preferences",
    cookie_necessary: "Necessary cookies (always on)",
    cookie_analytics: "Analytics cookies",
    manage_cookies: "Manage cookie preferences",
    search_placeholder: "Search experience or place…",
    related_title: "Recommended visits",
    what_to_bring: "What to bring",
    wtb_1: "Comfortable shoes and a bottle of water",
    wtb_2: "Swimwear, towel and sunscreen for sea experiences",
    wtb_3: "Layered clothing for trekking and mountains",
    boat_hero_note: "Private excursions • Sunset • Aperitivo • Custom experiences",
    boat_hero_sub2: "The sea of Naples lived from a completely different perspective.",
    discover_experience: "Discover the experience",
    faq_page_title: "Frequently asked questions",
    faq_page_sub: "Bookings, payments, cancellations, weather and everything you need to know.",
    need_help: "Need help?",
    booking_info: "Booking information",
    cancellation_policy: "Cancellation policy",
    all_faqs: "All FAQs",
    admin_title: "Admin area",
    admin_denied: "Restricted access. Sign in with an admin account.",
    admin_link: "Admin panel",
    tab_overview: "Overview",
    tab_requests: "Requests",
    tab_experiences: "Experiences",
    tab_users: "Users",
    stats_requests: "Total requests",
    stats_users: "Registered users",
    stats_experiences: "Active experiences",
    stats_favorites: "Saves",
    change_status: "Change status",
    featured_label: "Featured",
    save_label: "Save",
    saved_ok: "Saved",
    price_edit: "Price (from)",
    day_title: "Create your day in Campania",
    day_sub: "Choose what you want to live: we automatically combine sea, culture, taste and nature into a tailor-made itinerary.",
    day_pick: "What do you want to live?",
    day_area: "Where do you want to be?",
    day_area_all: "Anywhere in Campania",
    day_people: "How many?",
    day_generate: "Generate my itinerary",
    day_itinerary: "Your itinerary",
    day_morning: "Morning",
    day_afternoon: "Afternoon",
    day_evening: "Evening",
    day_empty: "Select at least two dimensions to generate the itinerary.",
    day_send: "Request this itinerary",
    day_sent_title: "Itinerary requested",
    day_sent_sub: "We have received your ideal itinerary. We will turn it into a concrete proposal and get back to you.",
    day_per_person: "per person",
    day_edit: "Edit selection",
    tab_contacts: "Contacts",
    nav_companion: "Companion",
    companion_title: "Flegrea Companion",
    companion_sub: "Your travel companion: readings and stories of the places you will visit, and your services always at hand with our staff's support.",
    langs_note: "coming soon",
    readings_title: "Readings & insights",
    min_read: "min read",
    back_companion: "All stories",
    your_services: "Your services",
    support_staff: "Staff support",
    support_title: "Need a hand?",
    support_sub: "Manage everything on your own — and when needed, our staff is one message away.",
    pay_online: "Pay online",
    pay_online_note: "Secure payment with Stripe. Availability remains subject to confirmation.",
    payment_processing: "Verifying your payment…",
    payment_success_title: "Payment successful",
    payment_success_sub: "Thank you! Your request is confirmed payment-side. We will contact you to confirm availability and experience details.",
    payment_success_pending_note: "If you completed the payment, confirmation may take a few minutes. For questions message us on WhatsApp.",
    payment_check_again: "Verification in progress",
    payment_cancel_title: "Payment cancelled",
    payment_cancel_sub: "No charge was made. You can retry anytime or send the request without online payment.",
    back_home: "Back to home",
    contact_title: "Request information",
    contact_sub: "Simple, quick, concise: write to us and we reply directly by email.",
    message_label: "Your message",
    send_message: "Send request",
    contact_sent: "Message sent",
    contact_sent_sub: "Thank you! We will reply shortly to the email address you provided.",
    contact_required: "Please fill in name, email and message.",
    contact_error: "Sending failed. Please retry or message us on WhatsApp.",
    contact_privacy_note: "By sending you accept the Privacy Policy. The message goes straight to info@flegreaexperience.com.",
    carousel_overline: "The territory",
    carousel_title: "Campania, for real",
    carousel_sub: "Real photographs from our tours. Coming soon: drone footage of archaeological sites and boat trips.",
    hero_line2: "meets fire.",
    hero_cta1: "Discover Experiences",
    hero_cta2: "Personalize Your Tour",
    dim_title: "What do you want to experience?",
    dim_sea: "SEA",
    dim_sea_desc: "Sea, islands, boats, canoes, coastlines and sunsets.",
    dim_culture: "CULTURE",
    dim_culture_desc: "Archaeology, history, art, boroughs and heritage.",
    dim_nature: "NATURE",
    dim_nature_desc: "Volcanoes, mountains, trails and outdoor activities.",
    dim_taste: "TASTE",
    dim_taste_desc: "Wine, cuisine, local products and food traditions.",
    explore_title: "Explore Campania",
    explore_sub: "From the Campi Flegrei to Naples, from the islands to Vesuvius, from the Coast to the Apennine mountains.",
    featured_title: "Featured Experiences",
    featured_sub: "The most loved experiences, curated by our team.",
    bysea_title: "Flegrea by Sea",
    bysea_sub: "See Campania from a different perspective.",
    bysea_cta: "Discover Boat Experiences",
    taste_title: "Taste Campania",
    taste_sub: "A journey through the flavors of Campania.",
    taste_cta: "Discover Taste Experiences",
    beyond_title: "Beyond the Coast",
    beyond_sub: "Discover the wild side of Campania.",
    beyond_cta: "Discover Nature Experiences",
    create_title: "Can't find what you're looking for?",
    create_sub: "Let's build your experience together: private tours, families, couples, groups, companies, romantic proposals, food and sea.",
    create_cta: "Create Your Tour",
    stay_title: "Stay With Us",
    stay_sub: "Selected B&Bs and residences: the ideal base to live the territory.",
    stay_cta: "Discover Stays",
    why_title: "Why Flegrea Experience?",
    why_1: "We know the territory beyond the guidebooks",
    why_2: "Authentic experiences, not just visits",
    why_3: "Small groups: more time, more attention, more authenticity",
    why_4: "Flexibility: we shape the experience around you",
    why_5: "We work with local partners and professionals",
    stories_title: "A land to be told",
    stories_sub: "Myths, eruptions and emperors: the stories of the Campi Flegrei, told by the people who live here.",
    final_title: "Your Campania Story Starts Here",
    final_sub: "Choose an experience, add what you love, or let us create it for you.",
    copy_1: "Campania is more than a destination.",
    copy_2: "It is ancient cities, volcanic landscapes, Mediterranean islands, hidden villages, mountain trails, extraordinary food and stories that have survived for centuries.",
    copy_3: "Flegrea Experience was created to help you experience all of it.",
    copy_4: "From the Campi Flegrei to Naples, from Procida and Ischia to Pompeii, from the Amalfi Coast to the mountains bordering Abruzzo and Molise.",
    copy_5: "Choose an experience. Add what you love. Or let us create it for you.",
    copy_cta: "Discover Campania",
    exp_page_title: "Experiences",
    exp_page_sub: "Curated experiences across Campania. Choose yours, or combine them with our taste add-ons.",
    filter_all: "All",
    filter_culture: "Culture & History",
    filter_sea: "Sea & Islands",
    filter_canoe: "Canoe & Water",
    filter_nature: "Nature & Outdoor",
    filter_food: "Food",
    filter_wine: "Wine",
    filter_private: "Private",
    filter_night: "Night",
    offer_badge: "-10%",
    launch_offer: "Launch offer — full price crossed out",
    all_destinations: "All destinations",
    results: "experiences",
    from: "from",
    per_person: "per person",
    price_note: "Indicative prices, to be confirmed at booking.",
    discover: "Discover the experience",
    the_experience: "The Experience",
    highlights: "Highlights",
    included: "Included",
    not_included: "Not Included",
    addons_title: "Make It Taste Better",
    addons_sub: "Add a taste of Campania to your experience.",
    addons_price_each: "per person",
    on_request: "On request",
    meet_guide: "Meet Your Guide",
    meet_guide_text: "Every experience is led by certified tour guides and local professionals selected by Flegrea Experience. Knowledge makes the difference.",
    good_to_know: "Good to Know",
    gtk_1: "Outdoor activities are subject to weather and sea conditions.",
    gtk_2: "Meeting point and logistics details are shared after booking.",
    gtk_3: "Private experiences can be customised on request.",
    faq_title: "FAQ",
    faq_q1: "Which languages are experiences available in?",
    faq_a1: "All experiences are available in Italian and English. Other languages on request.",
    faq_q2: "How does booking work?",
    faq_a2: "Contact us via WhatsApp or the form: we confirm availability and details, and reserve your experience. No online payment required at this stage.",
    faq_q3: "Can I customise an experience?",
    faq_a3: "Yes. Every experience can be enriched with food & wine add-ons, transfers and extra services, or rebuilt from scratch with Create Your Experience.",
    book_now: "Book Now",
    request_quote: "Request a Quote",
    duration: "Duration",
    group_size: "Group size",
    location_label: "Location",
    languages_label: "Languages",
    starting_price: "Starting price",
    dest_page_title: "Destinations",
    dest_page_sub: "Campania organised by territory: choose where, then choose how to live it.",
    dest_experiences: "Experiences in this destination",
    view_destination: "Explore",
    boat_page_sub: "See Campania from a different perspective.",
    boat_departure: "Departure",
    whats_included: "What's included",
    book_boat: "Book your sea experience",
    taste_page_sub: "A journey through the flavors of Campania.",
    make_taste: "Make It Taste Better",
    make_taste_sub: "Add a taste of Campania to your experience. Almost every experience can be enriched with a food & wine moment.",
    territories_title: "Territories of Taste",
    stay_page_sub: "Not just hotels: ideal bases to live the territory, with experiences at your doorstep.",
    check_availability: "Check Availability",
    rooms_label: "Rooms",
    services_label: "Services",
    nearby_exp: "Nearby experiences",
    stay_placeholder_note: "Selected property — details and availability being finalised.",
    step1: "Who are you travelling with?",
    step2: "How many?",
    step3: "When?",
    step4: "What do you love?",
    step5: "Where?",
    step6: "Add something special",
    step7: "Tell us more",
    step8: "Contact",
    opt_solo: "Solo",
    opt_couple: "Couple",
    opt_family: "Family",
    opt_friends: "Friends",
    opt_group: "Group",
    more_than_10: "More than 10 (custom request)",
    next: "Continue",
    back: "Back",
    submit: "Build My Experience",
    thankyou: "Thank you. Your Campania experience starts here.",
    thankyou_sub: "We have received your request. We will get back to you shortly to build your experience.",
    thankyou_wa: "Speed things up on WhatsApp",
    name_label: "Name",
    email_label: "Email",
    phone_label: "Phone",
    whatsapp_label: "WhatsApp",
    notes_placeholder: "Tell us what you dream of: special occasions, pace, must-sees, specific needs...",
    footer_experiences: "Experiences",
    footer_legal: "Legal",
    footer_contacts: "Contacts",
    footer_follow: "Follow us",
    privacy: "Privacy",
    cookie: "Cookie",
    terms: "Terms & Conditions",
    wa_float: "Plan Your Experience",
    wa_message: "Hello Flegrea Experience! I would like information about:",
    wa_book_prefix: "Hello! I would like to book the experience:",
    wa_quote_prefix: "Hello! I would like a quote for the experience:",
    wa_stay_prefix: "Hello! I would like to check availability for:",
    badge_PRIVATE: "Private",
    badge_SMALL_GROUP: "Small Group",
    badge_SUMMER: "Summer",
    badge_BOAT: "Boat",
    badge_FOOD: "Food",
    badge_NATURE: "Nature",
    loading: "Loading...",
    not_found: "Experience not found",
    back_experiences: "All experiences",
    back_destinations: "All destinations",
    about: "About",
    contact: "Contact",
    faq: "FAQ",
    nature_word: "Nature",
    step_of: "of",
    date_flexible: "My dates are flexible",
    chapters_title: "The story, chapter by chapter",
    anecdote_overline: "Stories & myths of the place",
    gallery_title: "The gallery",
    gallery_hint: "Scroll to explore",
    chat_float: "AI Assistant",
    chat_title: "Flegrea Assistant",
    chat_subtitle: "AI · experience & booking info",
    chat_placeholder: "Type a message...",
    chat_send: "Send",
    chat_greeting: "Hi! I'm the Flegrea Experience assistant. Ask me anything about our packages, prices or how to book — I'm here to help.",
    chat_error: "Something went wrong. Please try again in a moment or message us on WhatsApp at +39 379 334 6030.",
    booking_form_title: "Request information",
    booking_form_sub: "Fill in the form: we reply within 24 hours with availability and a tailored price.",
    stay_help_title: "Need a place to stay?",
    stay_help_sub: "We work with selected homes and B&Bs across the region. Tell us your dates and we will propose the ideal base, matched to your experiences.",
    stay_help_cta: "Request information",
    nl_title: "Newsletter",
    nl_sub: "Subscribe and get 10% off your first experience, plus stories and news from the territory.",
    nl_placeholder: "Your email",
    nl_cta: "Subscribe",
    nl_success: "Subscription confirmed! Your 10% discount is active: mention it when booking via WhatsApp or email.",
    nl_error: "Please check the email address and try again.",
    login_title: "Sign in",
    login_sub: "Sign in to your Flegrea Experience account",
    password_label: "Password",
    login_button: "Sign in",
    login_or: "or",
    login_google: "Continue with Google",
    tab_gallery: "Gallery",
    tab_stories: "Stories",
    admin_edit_content: "Edit",
    hero_sub: "Tours, excursions, sea, history and authentic flavours in the Campi Flegrei.",
    story_cta: "Discover the story",
    nav_all_experiences: "All experiences",
    nav_gallery: "Gallery",
    gallery_title: "Gallery",
    gallery_sub: "Every place from our experiences, frame by frame: from the volcanoes of the Campi Flegrei to the islands, from underground Naples to the lemons of Sorrento.",
    gallery_videos_title: "The territory in motion",
    gallery_videos_sub: "Footage from the sea and the land. New videos — drone shots and experience stories — coming soon.",
    gallery_coming_soon: "Coming soon",
    gallery_photos_title: "All photos",
    gallery_seo_title: "Gallery — Photos & Videos of the Campi Flegrei | Flegrea Experience",
    gallery_seo_desc: "Photos and videos of the Campi Flegrei and Campania: Pozzuoli, Baiae, Bacoli, Naples, Capri, Ischia, Procida, Sorrento, Pompeii and Mount Vesuvius.",
    hero_alt_1: "The Pozzuoli coastline and the Campi Flegrei from the sea",
    hero_alt_2: "The Aragonese Castle of Ischia",
    hero_alt_3: "The colourful houses of Corricella, Procida",
    hero_alt_4: "The Faraglioni rocks of Capri",
    hero_alt_5: "The fishing village of Sant'Angelo, Ischia",
    seo_home_title: "Flegrea Experience — Tours & Experiences in the Campi Flegrei",
    seo_home_desc: "Authentic experiences in the Campi Flegrei: guided tours of Pozzuoli, Baia and Bacoli, Lake Avernus and Monte Nuovo, boat trips to Capri, Ischia and Procida, history and food.",
    seo_exp_title: "Experiences in the Campi Flegrei — Tours, Sea, History & Flavours",
    seo_exp_desc: "The full collection of experiences: archaeology, volcanoes, boat tours, trekking and food experiences across Naples, the Campi Flegrei, Sorrento and the Amalfi Coast.",
    seo_dest_title: "Destinations — Campi Flegrei, Naples, Islands & Coast",
    seo_dest_desc: "Pozzuoli, Baia, Bacoli, Naples, Capri, Ischia, Procida, Sorrento, Pompeii, Caserta and the Matese: choose where to live your Campania experience.",
    seo_boat_title: "Capri & the Islands — Boat Experiences | Flegrea Experience",
    seo_boat_desc: "Boat tours between Capri, Ischia and Procida: private trips, sunsets and aperitivos at sea, departing from the Campi Flegrei.",
    seo_taste_title: "Taste — Food & Wine Experiences in Campania",
    seo_taste_desc: "Street food in Naples, volcanic wines, limoncello in Sorrento and traditional cuisine: the food and wine experiences of Flegrea Experience.",
    boat_cta_title: "Ready to set sail?",
    boat_cta_sub: "Message us on WhatsApp and let's plan your day at sea in the Campi Flegrei.",
  },
};

translations.de = de;
translations.es = es;
translations.zh = zh;

export const LANGS = [
  { code: "it", label: "Italiano", flag: "https://flagcdn.com/w40/it.png" },
  { code: "en", label: "English", flag: "https://flagcdn.com/w40/gb.png" },
  { code: "de", label: "Deutsch", flag: "https://flagcdn.com/w40/de.png" },
  { code: "es", label: "Español", flag: "https://flagcdn.com/w40/es.png" },
  { code: "zh", label: "中文", flag: "https://flagcdn.com/w40/cn.png" },
];

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("fx_lang") || "it");
  useEffect(() => {
    localStorage.setItem("fx_lang", lang);
    document.documentElement.lang = lang === "zh" ? "zh-CN" : lang;
  }, [lang]);
  const t = (key) => translations[lang]?.[key] || translations.en[key] || translations.it[key] || key;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

export function pick(obj, lang) {
  if (obj == null) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] || obj.en || obj.it || "";
}

export function waLink(message) {
  const num = process.env.REACT_APP_WHATSAPP_NUMBER || "390000000000";
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
}
